// src/pages/TestRoles.js
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../styles/TestRoles.css';

const TestRoles = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const switchToAdmin = () => {
    // Update user in localStorage to Admin role
    const updatedUser = { ...user, role: 'Admin' };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    // Reload to apply changes
    window.location.reload();
  };

  const switchToUser = () => {
    // Update user in localStorage to regular User role
    const updatedUser = { ...user, role: 'User' };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    // Reload to apply changes
    window.location.reload();
  };

  const testTeamAccess = () => {
    navigate('/team');
  };

  return (
    <div className="test-roles-container">
      <div className="test-roles-card">
        <h1>🔐 Role Testing Page</h1>
        <p className="subtitle">Test protected routes and role-based access</p>

        <div className="current-user-section">
          <h2>Current User Info:</h2>
          <div className="user-info-grid">
            <div className="info-item">
              <span className="label">Email:</span>
              <span className="value">{user?.email}</span>
            </div>
            <div className="info-item">
              <span className="label">Role:</span>
              <span className={`role-badge ${user?.role?.toLowerCase()}`}>
                {user?.role}
              </span>
            </div>
            <div className="info-item">
              <span className="label">Company:</span>
              <span className="value">{user?.companyName}</span>
            </div>
            <div className="info-item">
              <span className="label">Company ID:</span>
              <span className="value">{user?.companyId}</span>
            </div>
          </div>
        </div>

        <div className="actions-section">
          <h2>Switch Roles (Testing Only):</h2>
          <div className="button-group">
            <button 
              className="role-button admin-button"
              onClick={switchToAdmin}
              disabled={user?.role === 'Admin'}
            >
              {user?.role === 'Admin' ? '✓ Current Role' : 'Switch to Admin'}
            </button>
            <button 
              className="role-button user-button"
              onClick={switchToUser}
              disabled={user?.role === 'User'}
            >
              {user?.role === 'User' ? '✓ Current Role' : 'Switch to User'}
            </button>
          </div>
        </div>

        <div className="test-section">
          <h2>Test Protected Route:</h2>
          <p className="test-description">
            The <strong>/team</strong> route is Admin-only. Try accessing it with different roles:
          </p>
          <div className="test-info">
            {user?.role === 'Admin' ? (
              <div className="success-message">
                ✅ As an Admin, you SHOULD be able to access Team Management
              </div>
            ) : (
              <div className="warning-message">
                ⚠️ As a User, you should be BLOCKED and redirected to Dashboard
              </div>
            )}
          </div>
          <button 
            className="test-button"
            onClick={testTeamAccess}
          >
            Try Accessing Team Management →
          </button>
        </div>

        <div className="navigation-section">
          <h2>Quick Navigation:</h2>
          <div className="nav-buttons">
            <button onClick={() => navigate('/dashboard')}>Dashboard</button>
            <button onClick={() => navigate('/products')}>Products</button>
            <button onClick={() => navigate('/inventory')}>Inventory</button>
            <button onClick={() => navigate('/warehouse')}>Warehouse</button>
          </div>
        </div>

        <div className="logout-section">
          <button className="logout-button" onClick={logout}>
            Logout
          </button>
        </div>

        <div className="instructions">
          <h3>📝 Testing Instructions:</h3>
          <ol>
            <li>Click "Switch to Admin" to become an Admin user</li>
            <li>Click "Try Accessing Team Management" - You should see the Team page ✅</li>
            <li>Go back and click "Switch to User" to become a regular User</li>
            <li>Click "Try Accessing Team Management" again - You should be redirected to Dashboard ❌</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default TestRoles;